import { get3DModelExtension } from './jsHelper';

// Tool type used for the Re-stage / Product Swap template — items of this
// tool type are bypassed (no upload step required, only the notify call).
export const PRODUCT_SWAP_TOOL_TYPE = 'imagineaiv2_productswap';

// Returns the correct output extension for non-image tool types. For
// `imagineaiv2_3d`, the output may be `.glb` OR `.fbx`; detect from the
// upload-job-status `s3_url` instead of hard-coding. Other tool types
// return null so the caller leaves the extension untouched.
export const getFileExtensionForToolType = (toolType, s3Url) => {
  if (toolType === 'imagineaiv2_videogen') return 'mp4';
  if (toolType === 'imagineaiv2_3d') return get3DModelExtension(s3Url);
  return null;
};

// Swap the extension at the end of a URL/path while preserving any query/hash.
export const replaceFileExtension = (url, newExtension) => {
  if (!url) return url;
  return url.replace(/(\.[^./?#]+)(\?|#|$)/, `.${newExtension}$2`);
};

// Backend statuses that indicate the upstream job already failed —
// these tracking ids are bypassed via DELETE rather than processed.
export const isFailedUploadStatus = (status) => {
  if (!status) return false;
  const normalized = String(status).trim().toLowerCase();
  return normalized === 'failed' || normalized === 'error';
};

// Build a FormData from the server payload object. Django on the backend
// expects Python-style booleans ("True" / "False"); null / undefined values
// are dropped to keep the request body clean.
export const buildBackgroundUploadFormData = (payload) => {
  const formData = new FormData();
  if (!payload) return formData;
  Object.entries(payload).forEach(([key, value]) => {
    if (value === null || value === undefined) return;
    if (typeof value === 'boolean') {
      formData.append(key, value ? 'True' : 'False');
    } else {
      formData.append(key, String(value));
    }
  });
  return formData;
};

// Fetch a remote image URL as a Blob. Mirrors the `imageUrlToBlob` helper
// used in the reference TS implementation.
export const fetchImageUrlAsBlob = async (imageUrl) => {
  const response = await fetch(imageUrl, { mode: 'cors' });
  if (!response.ok) {
    throw new Error(`Failed to fetch image: ${response.status}`);
  }
  return response.blob();
};
